/** Core tokens always listed for a chain, even at zero balance (Sonar's "main assets"). */
export type DefaultToken = {
  chain: 'solana'
  address: string
  symbol: string
  name: string
  decimals: number
  imageUrl: string
}

export const SOL_MINT = 'So11111111111111111111111111111111111111112'
export const USDC_MINT = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'
export const USDT_MINT = 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'
/** US dollars held off chain (Kraken): a round flag, like Kraken's own USD mark (John, Nov 2 2026) */
export const USD_LOGO = '/brand/tokens/usd.svg'

/**
 * Official marks for the core tokens, served by us and keyed by mint so a
 * look-alike token named "USDT" never borrows the real logo. Third-party
 * logo feeds get these wrong (the token-list USDT has the T cut out).
 */
export const CORE_TOKEN_LOGOS: Record<string, string> = {
  [SOL_MINT]: '/brand/tokens/sol.png',
  [USDC_MINT]: '/brand/tokens/usdc.png',
  [USDT_MINT]: '/brand/tokens/usdt.png',
}

export function tokenLogo(address: string | undefined, fallback?: string) {
  return (address && CORE_TOKEN_LOGOS[address]) || fallback
}

export const SOLANA_DEFAULT_TOKENS: DefaultToken[] = [
  {
    chain: 'solana',
    address: USDC_MINT,
    symbol: 'USDC',
    name: 'USD Coin',
    decimals: 6,
    imageUrl: CORE_TOKEN_LOGOS[USDC_MINT],
  },
  {
    chain: 'solana',
    address: USDT_MINT,
    symbol: 'USDT',
    name: 'Tether USD',
    decimals: 6,
    imageUrl: CORE_TOKEN_LOGOS[USDT_MINT],
  },
]
